import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('vehicleFilters', {
  customKeys: {
    list: 'domains',
  },
  customEndpoints: {
    list: '/ui/vehicle_models/filter',
  },
});
